import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import React from 'react';
import Dialog from './dialog.jsx';
import style from './imgDialog.module.scss';

function PackageAiImgDialog({
  className = '',
  visible,
  setVisible,
  src,
  alt,
  onPrev,
  onNext,
}) {
  return (
    <Dialog
      className={`${style.imgDialog} ${className}`}
      visible={visible}
      setVisible={setVisible}
      onPrev={onPrev}
      onNext={onNext}
    >
      <div className={style.imgDialogBox}>
        <img className={style.imgDialogImg} src={src} alt={alt} />
      </div>
      {onPrev && (
        <div className={style.prevBtn} onClick={onPrev}>
          <LeftOutlined className={style.prevIcon} />
        </div>
      )}
      {onNext && (
        <div className={style.nextBtn} onClick={onNext}>
          <RightOutlined className={style.nextIcon} />
        </div>
      )}
    </Dialog>
  );
}

export default PackageAiImgDialog;
